import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from 'utils/apiClient';

/* eslint-disable import/prefer-default-export */
export const useKSVProvisioningStatusCheck = () => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['ksv', 'status'],
    queryFn: apiClient.Ksv.getKsvProvisioningStatus,
    retry: false,
    gcTime: 1500,
    refetchOnWindowFocus: false,
  });
};

export const useActivateKsv = () => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiClient.Ksv.activateKsv,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ksv', 'status'] });
    },
  });
};

export const useAccountData = (accountId: string) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['account-data', accountId],
    queryFn: () => apiClient.Ksv.getAccountData(accountId),
    staleTime: 1500,
    refetchOnWindowFocus: false,
    enabled: !!accountId,
  });
};
